import { RadioButton } from "primereact/radiobutton";
import { Image } from "primereact/image";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector, useAppDispatch } from "../../redux/hooks";
import { selectedPayment } from "../../redux/slices/payments";
import OrderService from "../../services/order/order.service";
import '../../assests/css/common/responsive-ui.css'

const NewInvoicePayment = (props: any) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const selectedPaymentMode = useAppSelector((state) => state.payments);
  const [selectedPaymentId, setSelectedPaymentId] = useState<number | null>(null);
  const [isCardAndUpiAllowed, setIsCardAndUpiAllowed] = useState<boolean>(false);

  // API call to check if Card and UPI options should be displayed
  const checkCardAndUpiEligibility = async () => {
    try {
      const data = await OrderService.checkCardAndUpiEligibility();
      setIsCardAndUpiAllowed(data.isSuccess);
    } catch (error) {
      console.error("Error checking Card and UPI eligibility:", error);
      setIsCardAndUpiAllowed(false);
    }
  };

  const paymentmodesdata = [
    {
      id: 11,
      mode: "Cash At Store",
      code: "CASH",
      modeImage: process.env.PUBLIC_URL + "/assests/images/cash.jpg",
      isSelected: false,
    },
    {
      id: 1,
      mode: t("payment_mode1"),
      code: "COD",
      modeImage: process.env.PUBLIC_URL + "/assests/images/cod.jpg",
      isSelected: true,
    },
    {
      id: 7,
      mode: "Online Payment",
      code: "OPTONL",
      modeImage: process.env.PUBLIC_URL + "/assests/images/credit-card.png",
      isSelected: false,
    },
    {
      id: 6,
      mode: "Payment Link",
      code: "",
      modeImage: process.env.PUBLIC_URL + "/assests/images/Betaallink.png",
      isSelected: true,
    },
  ];

  // Add UPI and Card only if API check returns true
  if (isCardAndUpiAllowed) {
    paymentmodesdata.push(
      {
        id: 5,
        mode: "UPI",
        code: "OPTUPI",
        modeImage: process.env.PUBLIC_URL + "/assests/images/oup.jpg",
        isSelected: true,
      },
      {
        id: 9,
        mode: "Card",
        code: "OPTONL",
        modeImage: process.env.PUBLIC_URL + "/assests/images/credit-card.png",
        isSelected: false,
      }
    );
  }

  if (props.displayOthersPayment) {
    paymentmodesdata.push({
      id: 2,
      mode: "Others ",
      code: "Others",
      modeImage: "",
      isSelected: false,
    });
  }

  useEffect(() => {
    if (selectedPaymentMode.selectedPayment === null) {
      setSelectedPaymentId(null);
    }
  }, [selectedPaymentMode]);

  useEffect(() => {
    props.updatePaymentId(selectedPaymentId);
  }, [selectedPaymentId, props]);

  useEffect(() => {
    // Call API to check Card and UPI eligibility
    checkCardAndUpiEligibility();
  }, []);

  const savePaymentMode = (e: { value: any }, value: any) => {
    const paymentId = Number(value.id);
    setSelectedPaymentId(paymentId);
    props.updatePaymentId(paymentId);
    if (props.displayOthersPayment && props.setOtherPaymentData) {
      props.setOtherPaymentData(value.id === 2);
    }
    dispatch(selectedPayment(value));
  };

  return (
    <div className="flex flex-wrap">
      {paymentmodesdata.map((category) => (
        <div key={category.id} className="ml-3 responsive-pay flex align-items-left">
          <RadioButton
            inputId={category.id.toString()}
            name="category"
            value={category}
            onChange={(e) => savePaymentMode(e, e.value)}
            checked={selectedPaymentId === category.id}
          />
          <label htmlFor={category.id.toString()} className="ml-2 font-medium">
            {category.mode}
          </label>
          {category.modeImage && (
            <div className="ml-2 payment-mode-image">
              <Image
                src={category.modeImage}
                alt={category.mode}
                width="24px"
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default NewInvoicePayment;